export default __webpack_public_path__ + "static/media/visa_logo.1fae40ca.svg";